<template>
  <div class="modal fade modalBgOp60" id="loadingModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalxLabel"
    aria-hidden="true" style="z-index: 1056;">
    <div class="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered" role="document">
      <div class="d-flex flex-column mx-5 mt-3 mb-5 justify-content-center w-100">
        <div class="spinner-border text-warning align-self-center loader-lg">
          Loading...
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { ref, onMounted, onBeforeUnmount, watch } from 'vue';
  import { useRoute } from 'vue-router';
  import eventBus from '@/eventBus/eventBus.js';
 
  // variable
  const loadingModal = ref(null);
  const route = useRoute();
  let wantsVisible = false;
  // end variable

  // function
  function showLoading () {
    wantsVisible = true;
    if (!loadingModal.value) {
      loadingModal.value = new bootstrap.Modal(document.getElementById('loadingModal'), { backdrop: 'static', keyboard: false });
    } 
    
    syncVisibility();
  }

  function hideLoading () {
    wantsVisible = false;
    syncVisibility();
  }

  function syncVisibility () {
    if (wantsVisible) loadingModal.value?.show();
    else loadingModal.value?.hide();
  }
  // end function

  // Loading belongs to the page that started it, not the next login screen.
  watch(() => route.fullPath, hideLoading, { flush: 'sync' });

  onMounted(() => {
    const element = document.getElementById('loadingModal');
    if (!loadingModal.value) loadingModal.value = new bootstrap.Modal(element, { backdrop: 'static', keyboard: false });

    // Bootstrap ignores show/hide during a fade. Apply the latest requested
    // visibility again once that transition completes.
    element.addEventListener('shown.bs.modal', syncVisibility);
    element.addEventListener('hidden.bs.modal', syncVisibility);

    // init event bus
    eventBus.on('showLoadingModal', showLoading);

    eventBus.on('hideLoadingModal', hideLoading);
  });

  onBeforeUnmount(() => {
    eventBus.off('showLoadingModal', showLoading);
    eventBus.off('hideLoadingModal', hideLoading);
    const element = document.getElementById('loadingModal');
    element?.removeEventListener('shown.bs.modal', syncVisibility);
    element?.removeEventListener('hidden.bs.modal', syncVisibility);
    loadingModal.value?.dispose();
  });

  defineExpose({
    showLoading,
    hideLoading
  });
</script>
